import React from 'react';
import { Box, Stack } from '@mui/material';
import { AiGeneratedChip } from '@marageti/z4-lib';
import SuggestionFieldActions from './suggestion-field-actions';

type SuggestionSlotProps = {
  children: React.ReactNode;
  onApply: () => void;
  onDismiss: () => void;
  disabled?: boolean;
  showChip?: boolean;
  /**
   * When true, the whole slot renders inside a light-grey container (used
   * for the Travel Preferences subsections per the Figma).
   */
  boxed?: boolean;
};

/**
 * Standard layout for a single suggestion preview: the AI GENERATED chip,
 * the suggested content, and the inline Apply / Dismiss action row.
 * Callers provide the rendered preview content via children so each card
 * can format its own data (bulleted list, rich text, date rows, etc.).
 */
const SuggestionSlot = ({
  children,
  onApply,
  onDismiss,
  disabled = false,
  showChip = true,
  boxed = false,
}: SuggestionSlotProps) => {
  const content = (
    <Stack spacing={1}>
      {showChip && (
        <Box>
          <AiGeneratedChip />
        </Box>
      )}
      <Box>{children}</Box>
      <SuggestionFieldActions
        onApply={onApply}
        onDismiss={onDismiss}
        disabled={disabled}
      />
    </Stack>
  );

  if (!boxed) return content;

  return (
    <Box
      sx={{
        bgcolor: 'neutral.light',
        borderRadius: '8px',
        p: 1.5,
        pl: 0,
      }}
    >
      {content}
    </Box>
  );
};

export default SuggestionSlot;
